export type CalendarSummaryPeriod = 'weekly' | 'fortnightly' | 'monthly';

export interface CalendarSummaryDateRange {
  startDate: Date;
  endDate: Date;
}

export function getCalendarSummaryDateRange(
  anchorDate: Date,
  period: CalendarSummaryPeriod
): CalendarSummaryDateRange {
  const year = anchorDate.getFullYear();
  const month = anchorDate.getMonth();
  const day = anchorDate.getDate();

  if (period === 'weekly') {
    const mondayOffset = (anchorDate.getDay() + 6) % 7;
    const startDate = new Date(year, month, day - mondayOffset);
    const endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 6);
    return { startDate, endDate };
  }

  if (period === 'fortnightly') {
    const startDay = day <= 15 ? 1 : 16;
    const endDay = day <= 15 ? 15 : new Date(year, month + 1, 0).getDate();
    return {
      startDate: new Date(year, month, startDay),
      endDate: new Date(year, month, endDay)
    };
  }

  return {
    startDate: new Date(year, month, 1),
    endDate: new Date(year, month + 1, 0)
  };
}

export function formatCalendarApiDate(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}
